const optionsS1 = { startVal: 81, suffix: "%" };
let stat1 = new CountUp("stats-1", 86, optionsS1);

const optionsS2 = { startVal: 59, suffix: "%" };
let stat2 = new CountUp("stats-2", 64, optionsS2);

const optionsS4 = { startVal: 910 };
let stat4 = new CountUp("stats-4", 918, optionsS4);

let toutS1, toutS2;

if (!stat1.error) {
  const elementS1 = document.querySelector("[data-anim-4]");
  const elementS4 = document.querySelector("[data-anim-1]");

  const handleMouseEnterTouchStart = () => {
    toutS1 = setTimeout(() => {
      stat1.start();
      stat1.update(86);
    }, 800);

    toutS2 = setTimeout(() => {
      stat2.start();
      stat2.update(64);
    }, 800);
  };

  const handleMouseLeaveTouchEnd = () => {
    clearTimeout(toutS1);
    clearTimeout(toutS2);
    stat1.update(81);
    stat2.update(59);
  };

  elementS1.addEventListener("mouseenter", handleMouseEnterTouchStart);
  elementS1.addEventListener("mouseleave", handleMouseLeaveTouchEnd);

  elementS1.addEventListener("touchstart", handleMouseEnterTouchStart);
  document.addEventListener("touchstart", (e) => {
    // If the touch target is outside elementS1, trigger mouseleave behavior
    if (!elementS1.contains(e.target)) {
      handleMouseLeaveTouchEnd();
    }
  });

  elementS4.addEventListener("mouseenter", () => {
    stat4.start();
    stat4.update(918);
  });

  elementS4.addEventListener("mouseleave", () => {
    stat4.update(910);
  });

  elementS4.addEventListener("touchstart", () => {
    stat4.start();
    stat4.update(918);
  });

  document.addEventListener("touchstart", (e) => {
    // If the touch target is outside elementS4, trigger mouseleave behavior
    if (!elementS4.contains(e.target)) {
      stat4.update(910);
    }
  });
}

// Funkcja usuwająca efekt hover ze wszystkich kafelków
function removeHoverFromAllTiles() {
  const tiles = document.querySelectorAll(".tile--1, .tile--2, .tile--3, .tile--4");
  tiles.forEach((tile) => {
    tile.classList.remove("hover"); // Usuwanie klasy hover
  });
}

// Funkcja obsługująca hover po dotknięciu
function handleTileTouch(tile) {
  removeHoverFromAllTiles(); // Usunięcie hover ze wszystkich kafelków przed nałożeniem na wybrany
  tile.classList.add("hover"); // Dodanie efektu hover do aktualnego elementu
}

// Funkcja inicjalizująca obsługę dotknięcia i najechania myszką dla kafelków
function initTileListeners() {
  const tiles = document.querySelectorAll(".tile--1, .tile--2, .tile--3, .tile--4");

  tiles.forEach((tile) => {
    // Obsługa dotknięcia na urządzeniach dotykowych
    tile.addEventListener("touchstart", (event) => {
      event.stopPropagation(); // Zatrzymanie propagacji, aby kliknięcie kafelka nie liczyło się jako kliknięcie poza nim
      handleTileTouch(event.currentTarget); // Wywołanie efektu hover dla dotkniętego kafelka
    });

    // Obsługa najechania myszką
    tile.addEventListener("mouseenter", () => {
      tile.classList.add("hover"); // Dodanie efektu hover po najechaniu myszką
    });

    // Obsługa zjechania myszką
    tile.addEventListener("mouseleave", () => {
      tile.classList.remove("hover"); // Usunięcie efektu hover po zjechaniu myszką
    });
  });

  // Usunięcie efektu hover po kliknięciu w dowolne inne miejsce na ekranie (na urządzeniach dotykowych)
  document.addEventListener("touchstart", (event) => {
    // Jeśli dotknięty element nie jest kafelkiem
    if (!event.target.closest(".tile--1, .tile--2, .tile--3, .tile--4")) {
      removeHoverFromAllTiles();
    }
  });
}

// Inicjalizacja po załadowaniu dokumentu
document.addEventListener("DOMContentLoaded", () => {
  initTileListeners();
});

document.addEventListener("DOMContentLoaded", () => {
  const element = document.querySelector("[data-anim-2]");
  let timeout1, timeout2;

  if (element) {
    // Obsługa najechania myszką (hover)
    element.addEventListener("mouseenter", () => {
      element.classList.add("anim-step-1");

      timeout1 = setTimeout(() => {
        element.classList.add("anim-step-2");
      }, 1500);

      clearTimeout(timeout2);
    });

    element.addEventListener("mouseleave", () => {
      element.classList.remove("anim-step-2");

      timeout2 = setTimeout(() => {
        element.classList.remove("anim-step-1");
      }, 1500);

      clearTimeout(timeout1);
    });

    // Obsługa dotyku
    element.addEventListener("touchstart", () => {
      element.classList.add("anim-step-1");

      timeout1 = setTimeout(() => {
        element.classList.add("anim-step-2");
      }, 1500);

      clearTimeout(timeout2);
    });

    element.addEventListener("touchend", () => {
      timeout2 = setTimeout(() => {
        element.classList.remove("anim-step-1");
        element.classList.remove("anim-step-2");
      }, 1500);

      clearTimeout(timeout1);
    });
  }

  // Usuwanie klas, jeśli dotknięty zostanie inny element
  document.addEventListener("touchstart", (event) => {
    if (event.target && element) {
      if (!element.contains(event.target)) {
        element.classList.remove("anim-step-1");
        element.classList.remove("anim-step-2");
        clearTimeout(timeout1);
        clearTimeout(timeout2);
      }
    }
  });
});
